module.exports = __webpack_public_path__ + "img/exhibition-img2.188523a5.png";